import React from 'react'
import PropTypes from 'prop-types'

export default class LineItemsDetailsHeader extends React.Component {

  static propTypes = {
    onRequestClose: PropTypes.func.isRequired
  }

  handleCloseClicked = () => {
    this.props.onRequestClose()
  }

  render() {
    return (
      <div style={styles.container}>
        <div style={styles.label}>Details</div>
        <div style={styles.close} onClick={this.handleCloseClicked}>+</div>
      </div>
    )
  }

}

const styles = {

  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#527da3',
    padding: 12,
    borderTopLeftRadius: 2,
    borderTopRightRadius: 2
  },

  label: {
    fontSize: 16,
    color: '#fff'
  },

  close: {
    color: '#fff',
    fontSize: 24,
    transform: 'rotate(45deg)',
    cursor: 'pointer'
  }

}


// WEBPACK FOOTER //
// ./src/schedule/common/modules/lineItems/LineItemsDetailsHeader.js